"use strict";Object.defineProperty(exports, "__esModule", {value: true});var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/FormItem.tsx
var _antd = require('antd');
var _reacthookform = require('react-hook-form');
var _jsxruntime = require('react/jsx-runtime');
var FormItem = (_a) => {
  var _b = _a, {
    children,
    control,
    name,
    help
  } = _b, props = __objRest(_b, [
    "children",
    "control",
    "name",
    "help"
  ]);
  var _a2, _b2;
  const { field, fieldState } = _reacthookform.useController.call(void 0, { name, control });
  const handleNormalize = (value) => {
    field.onChange(value);
    return value;
  };
  return /* @__PURE__ */ _jsxruntime.jsx.call(void 0, 
    _antd.Form.Item,
    __spreadProps(__spreadValues({}, props), {
      name,
      initialValue: field.value,
      normalize: handleNormalize,
      validateStatus: fieldState.invalid ? "error" : void 0,
      help: (_b2 = (_a2 = fieldState.error) == null ? void 0 : _a2.message) != null ? _b2 : help,
      children
    })
  );
};


exports.FormItem = FormItem;
